<template>
  <PageLayout
    class="clients-page"
    :style="{ maxWidth: computedMaxWidth + 'px' }"
  >
    <PageTitle class="page-title">Клієнти</PageTitle>
    <Clients />
  </PageLayout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Clients from '../../views/clients';
import { pages } from '@/entities/current-page';
import { PageLayout } from '@/shared/ui/layouts';
import { PageTitle } from '@/shared/ui/page-title';

export default {
  created() {
    this.changeActivePage(pages.CLIENTS_AND_PARTNERS);
  },
  components: { PageTitle, PageLayout, Clients },
  computed: {
    ...mapGetters('layoutModule', ['isMobile', 'isTablet', 'windowWidth']),
    computedMaxWidth() {
      if (this.isMobile || this.isTablet) {
        return this.windowWidth;
      }

      return this.windowWidth - 160;
    },
  },
  methods: {
    ...mapActions('currentPageModule', ['changeActivePage']),
  },
};
</script>

<style lang="scss" scoped>
.page-title {
  font-size: 30px;
  line-height: 44px;
  color: #24282c;
  font-weight: 700;
  margin-bottom: 26px !important;
}

::v-deep button {
  text-align: center;
}

::v-deep input {
    border: 1px solid #dde2e5 !important;
    border-radius: 3px !important;

    &:hover {
        border-color: #ffad3d !important;
    }
}

::v-deep .multiselect__input {
    border: none !important;
}
</style>
